import * as yup from 'yup'
import { VALIDATION } from 'utils/globalConstant'

export const validationSchema = yup.object({
  holiday_name: yup.string().required(VALIDATION.required).max(191, VALIDATION.max),
  holiday_type: yup.string().required(VALIDATION.required),
  from_date: yup.string().required(VALIDATION.required),
  isApply: yup.string()
})
